export default [
  {
    id: 'event',
    name: 'Match Fee',
  },
  {
    id: 'event-variable',
    name: 'Match Variable Fee',
  },
  {
    id: 'walkover',
    name: 'Forfeit Fee',
  },
  {
    id: 'walkover-covid',
    name: 'Forfeit COVID Fee',
  },
];
